import { PageDetail, CircleLoader } from 'components';
import { Formik, Form } from 'formik';
import { makeStyles, Theme, useTheme, Card, Button, CardContent, CircularProgress } from '@material-ui/core';
import { VitecUserForm } from './components';
import { Save as SaveIcon } from '@material-ui/icons';
import { useContext } from 'react';
import { vitecUserContext, vitecUserSchema } from './VitecUserContext';


let useStyles = makeStyles((theme: Theme) => ({
    card: {
        marginTop: 16
    },
    button: {
        marginTop: 16,
        marginBottom: 16,
        float: "right"
    }
}));


let VitecUser = () => {
    let theme = useTheme();
    let classes = useStyles(theme);

    let service = useContext(vitecUserContext);

    let title = service.isNew ? 'New user' : 'Edit user';


    return (
        <PageDetail title={title}>
            <Formik
                enableReinitialize={true}
                initialValues={service.vitecUser}
                validationSchema={vitecUserSchema}
                onSubmit={(values, action) => {
                    service.saveVitecUser(values);
                    action.setSubmitting(false);
                }}
            >
                <Form>
                    {service.isLoading && <CircleLoader />}
                    {service.isLoading === false &&
                        <>
                            <Card className={classes.card}>
                                <CardContent>
                                    <VitecUserForm />
                                </CardContent>
                            </Card>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                disabled={service.isSaving}
                                type="submit"
                            >
                                <SaveIcon /> Save
                                {service.isSaving && <>&nbsp;<CircularProgress size={16} /></>}
                            </Button>
                        </>
                    }
                </Form>
            </Formik>
        </PageDetail>
    )
}

export default VitecUser;